import React, { useState, useEffect, useCallback } from "react";
import LoadingInComponent from "../../Components/LoadingInComponent";
import ImportLogTable from "../../Components/Tables/ImportLogTable";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useToast } from "../../Components/Toast";
import { GET_IMPORT_LOG_DETAILS_API } from "../../Constant/api";
import Breadcrumb from "../../Components/Breadcrumb";

const ImportLogDetails = () => {
  const [loading, setLoading] = useState(false);
  const [importDetails, setImportDetails] = useState([]);
  const [importDetailsMeta, setImportDetailsMeta] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchCleared, setIsSearchCleared] = useState(false);
  const [perPage, setPerPage] = useState(10);

  const { toast } = useToast();
  const location = useLocation();

  const importId = location.state.importId;
  const fileName = location.state.fileName;

  const handlePerPageChange = (e) => {
    setPerPage(e.target.value);
    fetchImportDetails(1, e.target.value);
  };

  const clearFilter = () => {
    setSearchTerm("");
    setIsSearchCleared(true);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    if (e.key === "Enter") {
      fetchImportDetails();
    }
  };

  const fetchImportDetails = useCallback(async (page = 1, perPageValue = perPage) => {
    setLoading(true);
    try {
      axios
        .get(GET_IMPORT_LOG_DETAILS_API, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
          },
          params: {
            importId: importId,
            page: page,
            perPage: perPageValue,
            search: searchTerm,
          },
        })
        .then((response) => {
          setLoading(false);
          setImportDetails(response.data.data);
          setImportDetailsMeta(response.data.meta.pagination);
        })
        .catch((error) => {
          console.error("Error fetching `import details`:", error);
          setLoading(false);
          toast("Failed to fetch import details.", "error");
        });
    } catch (error) {
      setLoading(false);
      toast("Failed to fetch import details.", "error");
      console.error("Error fetching `import details`:", error);
    }
  }, [importId, perPage, searchTerm, toast]);

  const handlePageClick = (e) => {
    const selectedPage = e.selected + 1;
    fetchImportDetails(selectedPage, perPage);
  };

  useEffect(() => {
    fetchImportDetails();
  }, [fetchImportDetails]);

  useEffect(() => {
    if (isSearchCleared && searchTerm === "") {
      fetchImportDetails();
      setIsSearchCleared(false);
    }
  }, [isSearchCleared, searchTerm, fetchImportDetails]);

  const breadcrumbItems = [
    { label: "Guest List Import Log", to: "/guest-import-log" },
    { label: fileName },
    { label: "List" },
  ];

  return (
    <div className="flex flex-col w-full h-full">
      <LoadingInComponent isLoading={loading}>
        <div className="flex flex-col w-full h-full p-[16px] md:p-[32px] no-scrollbar overflow-y-auto gap-[12px] md:gap-[24px]">
          {/* Breadcrumb */}
          <Breadcrumb items={breadcrumbItems} />

          {/* Title row */}
          <div className="flex w-full justify-between items-center">
            <h1 className="text-[29px]">{fileName}</h1>
          </div>

          {/* Guest list table */}
          {importDetails && (
            <ImportLogTable
              type="details"
              data={importDetails}
              meta={importDetailsMeta}
              handlePageClick={handlePageClick}
              searchTerm={searchTerm}
              handleSearch={handleSearch}
              perPage={perPage}
              handlePerPageChange={handlePerPageChange}
              clearFilter={clearFilter}
            />
          )}
        </div>
      </LoadingInComponent>
    </div>
  );
};

export default ImportLogDetails;
